angular.module('eatself')
.filter('not', function() {
  return function(input) {
    return !input;
  };
})